<template>
  <a
    href="https://www.portexai.com"
    target="_blank"
    rel="noopener noreferrer"
    class="portex-logo-container"
  >
  
    <img
      src="/images/logo.png"
      class="portex-logo"
      alt="PORTEXAI"
    >
  </a>
</template>
  
  <script setup>
  </script>
  
  <style>
  
  .portex-logo-container {
      display: flex;
      align-items: center; 
      width: fit-content; 
      height: 100%; 
  }
  
  .portex-logo {
      width: auto;
      max-height: 70px;
      height: auto;
  }
  </style>
  